import { Component, Input, OnInit } from '@angular/core';

// Version de Pannel utilise pour les widget
// Parmi les particularites de ces widgets:
// - Les panneaux des widgets sont toujours expandable/collapsable
// - Les widgets possedent une icone devant le titre de leur panneau
// - Le titre est clickable pour acceder a la version complete de ce que montre le widget
// - L'etat d'affichage du panneau et stockee de maniere permanente dans le localStorage
@Component({
	selector: 'widget-pannel',
	templateUrl: 'widget-pannel.html'
})
export class WidgetPannelComponent implements OnInit {
	folded: boolean = false;

	constructor() {
	}

	@Input() storageName!: string;
	@Input() pannelClass!: string;
	@Input() iconClass!: string;
	@Input() title!: string;
	@Input() href!: string;
	@Input() alt: string | null = null;
	
	ngOnInit() {
		// Attention, dans le localStorage, la valure est stockee sous forme de string
		let storedValue: string = localStorage['ngStorage-' + this.storageName];
		if (storedValue !== undefined) {
			this.folded = storedValue === 'true';
		}
	}
	
	onFoldedChange(value: boolean) {
		// Quand le panneau est plie/deplie, on sauvegarde l'etat dans le localStorage
		// On conserve la forme string par souci d'heritage avec l'ancienne logique angular-js
		localStorage['ngStorage-' + this.storageName] = "" + value;
	}
}